import { BaseModel } from "@/store/feathers/feathers.client.js";
import uid from 'quasar/src/utils/uid.js';

export default class Forms extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "Forms";

  // eslint-disable-next-line no-unused-vars
  static instanceDefaults(data, { models, store }) {
    return {
      type: null,
      token: null,
      is_test: false,
      is_inactive: false,
      expires: null,
      session_id: null,
      name: null,
      description: null,
      id_form: null,
      status: {},
      card: {
        number: null,
        cvv: null,
        month: null,
        year: null,
        holder: null,
        brand: null,
        nickname: null,
        save_token: false,
        token: null,
        billing: {
          postal_code: null,
          street_1: null,
          street_2: null,
          city: null,
          state_code: null,
          country_code: null,
          latitude: null,
          longitude: null,
        },
      },
      ach: {
        save_token: false,
        nickname: null,
        account: null,
        owner: null,
        routing: null,
        kind: null,
        type: null,
        bank: {
          name: null,
          contact: null,
          email: null,
          phone: null,
          street: null,
          city: null,
          state_code: null,
          postal_code: null,
          website: null,
        }
      },
      customer: {
        id: null,
        display_name: null,
        first_name: null,
        last_name: null,
        dba_name: null,
        email: null,
        phone: null,
        phone_extension: null,
        website: null,
        id_account: null,
        id_customer: null,
        default_address: {
          enable: false,
          city: null,
          name: null,
          phone: null,
          contact: null,
          street_1: null,
          street_2: null,
          street_3: null,
          state_code: null,
          postal_code: null,
          country_code: null,
          phone_extension: null,
        },
        billing_address: {
          enable: false,
          city: null,
          name: null,
          phone: null,
          contact: null,
          street_1: null,
          street_2: null,
          street_3: null,
          state_code: null,
          postal_code: null,
          country_code: null,
          phone_extension: null,
        },
        shipping_address: {
          enable: false,
          city: null,
          name: null,
          phone: null,
          contact: null,
          street_1: null,
          street_2: null,
          street_3: null,
          state_code: null,
          postal_code: null,
          country_code: null,
          phone_extension: null,
        }
      },
      shipping: {},
      pii: {},
      cart: {},
      brand: {},
      notes: [],
      tags: [],
      meta_data: {},
      template_id: null,
      transaction_id: null,
      receipt_template_id: null,
      app_id: null,
      tenant_id: null,
      developer_id: null,
      group_id: null,
      reseller_id: null,
      merchant_id: null,
      mid_id: null,
      host_mid_id: null,
    }
  }

  // eslint-disable-next-line no-unused-vars
  static setupInstance(data, { models, store }) {

    if (!data.card) {
      data.card = {
        number: null,
        cvv: null,
        month: null,
        year: null,
        holder: null,
        brand: null,
        nickname: null,
        save_token: false,
        token: null,
        billing: {
          postal_code: null,
          street_1: null,
          street_2: null,
          city: null,
          state_code: null,
          country_code: null
        },
      }
    }

    if (!data.ach) {
      data.ach = {
        save_token: false,
        nickname: null,
        account: null,
        owner: null,
        routing: null,
        kind: null,
        type: null,
        bank: {
          name: null,
          contact: null,
          email: null,
          phone: null,
          street: null,
          city: null,
          state_code: null,
          postal_code: null,
          website: null,
        }
      }
    }

    if (data.card && data.card.id) {
      data.card = new models.api.VaultCards(data.card);
    }

    if (data.ach && data.ach.id) {
      data.ach = new models.api.VaultBanks(data.ach);
    }

    if (data.shipping && data.shipping.id) {
      data.shipping = new models.api.VaultBanks(data.shipping);
    }

    if (data.pii && data.pii.id) {
      data.pii = new models.api.VaultPii(data.pii);
    }

    if (data.customer && data.customer.company && data.customer.company.id) {
      data.customer.company = new models.api.Companies(data.customer.company);
    }

    if (data.customer && data.customer.contact && data.customer.contact.id) {
      data.customer.contact = new models.api.Contacts(data.customer.contact);
    }

    if (data.mid && data.mid.id) {
      data.mid = new models.api.Mids(data.mid);
    }

    if (data.template) {
      data.template = new models.api.FormTemplates(data.template);
    }

    if (data.transaction) {
      data.transaction = new models.api.Transactions(data.transaction);
    }

    if (data.receipt_template_id) {
      data.receipt_template_id = new models.api.ReceiptTemplates(data.receipt_template);
    }

    if (data.settings) {
      data.settings = new models.api.FormSettings(data.settings);
    }

    if (data.cart && data.cart.id) {
      data.cart = new models.api.Carts(data.cart);
    }
    // if (data && data.id.startsWith('receipt-')) {
    //   data = new models.api.Receipts(data);
    //   store.state.config.form_type = 'receipt';
    //   store.state.ids.form_id = data.id;
    // }

    // console.log("EMBEDDED FORMS STORE MODEL DATA", data);
    return data;
  }
}
